var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRisksIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21.022,
    viewBox: "0 0 24 21.022",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning-208",
    transform: "translate(0.001 -63.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20822",
    "data-name": "Path 20822",
    d: "M21.522,85.021H2.5a2.609,2.609,0,0,1-2.2-1.3,2.757,2.757,0,0,1,0-2.5L9.81,65.2a2.751,2.751,0,0,1,2.2-1.2,2.44,2.44,0,0,1,2.1,1.2l9.51,16.017a2.273,2.273,0,0,1,0,2.5,2.335,2.335,0,0,1-2.1,1.3ZM11.611,66.2,2.1,82.218a.447.447,0,0,0,0,.5c0,.1.2.2.4.2h19.02a.434.434,0,0,0,.4-.2.447.447,0,0,0,0-.5L12.412,66.2a.5.5,0,0,0-.8,0Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20823",
    "data-name": "Path 20823",
    d: "M470.334,351.844a.946.946,0,0,1-1-1v-.5a1,1,0,0,1,2,0v.5A.946.946,0,0,1,470.334,351.844Zm0-3.5a.946.946,0,0,1-1-1v-5.005a1,1,0,0,1,2,0v5.005A.946.946,0,0,1,470.334,348.341Z",
    transform: "translate(-458.323 -270.827)",
    fill: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisksIcon);
export default __webpack_public_path__ + "static/media/risks-icon.11c6776e6336bdf86bd22e494e6cad6d.svg";
export { ForwardRef as ReactComponent };